module.exports = __webpack_public_path__ + "img/logo-transparent.67a53c61.webp";